
import(/* webpackChunkName: "semantic-theme" */"@semantic-theme").then(()=>{});
import cuid from "cuid";
import React from 'react'
import { withTranslation } from 'react-i18next';
import {List, Icon, Dimmer, Message} from 'semantic-ui-react'
import { ThemeProvider } from 'styled-components';
import {ReactElementResize} from 'react-element-resize';
import { Box, Flex } from 'rebass'

import { map } from 'lodash'

import theme from '~/theme'
import { __ } from '~/i18n'
import Video from '~/components/video'
import { SimpleErrorBoundary } from '~/components/errors'
import { VIDEO_EMBED_KEY } from "../definitions";
import {
  Description,
  VideoContainer,
  VideoPlayerContainer,
  VideoFooter,
  VideoTitle,
  Playlist,
  PosterContainer,
  Poster,
  AlignBox
} from "~/components/video-playlist";

import logic from './logic'


class EmbedVideoPlayer extends React.Component {
  state = {
  };

  playVideo = (index) => {
    const { setActiveVideo } = this.props.actions;

    setActiveVideo(index);
  };

  onTrailerStateChange = (state, prevState) => {
    const { trailerFinished, trailerRestarted } = this.props.actions;
    if(!prevState.ended && state.ended) {
      trailerFinished();
    } else if(prevState.ended && !state.ended) {
      trailerRestarted();
    }
  };

  handleHeightChange = ({width, height}) => {
    if(this.state.videoHeight !== height) {
      this.setState({videoHeight: height});
    }
  };

  render() {
    const {
      videoPlayer,
      trailerDone,
      activeVideo,
      showPlaylist,
      mainPoster,
      title,
      hasAccess,
      description,
      hideVideo,
      failed
    } = this.props;

    const { videoHeight } = this.state;

    let videoContent;

    if(failed) {
      return (
        <Message error>
          <p>{ __('Error loading the video.')}</p>
        </Message>
      )
    }


    if (videoPlayer && hasAccess && activeVideo) {
      const videos = map(videoPlayer.videos, (video, index) => {
        return (
          <List.Item active={ video.id === activeVideo.id } as='a' key={ video.id } onClick={(e) => {
            e.preventDefault();
            this.playVideo( index )
          }}>
            <Icon name='play circle outline' size='large' />
            <List.Content>
              <List.Header>{ video.name || `${__('Video')} #${ index + 1}` }</List.Header>
            </List.Content>
          </List.Item>
        );
      });
      videoContent = (
        <Flex flexWrap='wrap'>
          <Box width={[1, showPlaylist ? 10/16 : 1, showPlaylist ? 12/16 : 1]}>
            <ReactElementResize debounceTimeout={50} onResize={this.handleHeightChange}>
              { () => <Video
                hlsSource={ activeVideo.hls_source }
                poster={ mainPoster }
                onStateChange={ this.onTrailerStateChange }
              /> }
            </ReactElementResize>
          </Box>
          { showPlaylist ? <Box width={[1, 6/16, 4/16]}>
            <Playlist relaxed divided size="big" videoHeight={ videoHeight }>
              { videos }
            </Playlist>
          </Box> : null }
        </Flex>
      )
    } else if (videoPlayer && videoPlayer.trailer_hls_source && !hasAccess) {
      videoContent = (
        <Flex flexWrap='wrap'>
          <Box width={1}>
            <Video
              hlsSource={ videoPlayer.trailer_hls_source }
              poster={ mainPoster }
              onStateChange={ this.onTrailerStateChange }
            />
          </Box>
        </Flex>
      )
    } else if (videoPlayer && !videoPlayer.trailer_hls_source && !hasAccess && mainPoster) {
      videoContent = (
        <Flex flexWrap='wrap'>
          <Box width={1}>
            <PosterContainer>
              <Poster image={mainPoster}/>
            </PosterContainer>
          </Box>
        </Flex>
      )
    }

    return (
      <ThemeProvider theme={theme}>
        <VideoContainer className="gfy-plugin-container">
          { !hideVideo ? <VideoPlayerContainer>
            { videoContent }
          </VideoPlayerContainer> : null }
          <VideoFooter>
            { videoPlayer ?
              <div>
                <Flex flexWrap='wrap' py={ 4 } alignItems={ 'center' } mx={ -4 }>
                  <Box px={ 4 } width={ [ 0.5, 10/16, 10/16 ] }>
                    <VideoTitle>{ title }</VideoTitle>
                  </Box>
                  <AlignBox textAlign='right' px={ 4 } width={ [ 0.5, 6/16, 6/16 ] }>
                  </AlignBox>
                </Flex>
                { description ? <Flex flexWrap='wrap' py={ 4 } alignItems={ 'center' } mx={ -4 }>
                  <Box px={ 4 } width={ 1 }>
                    <SimpleErrorBoundary message={ __('Unable to load video description.') }>
                      <Description description={ description } />
                    </SimpleErrorBoundary>
                  </Box>
                </Flex> : null }
              </div>
              : null }
          </VideoFooter>
        </VideoContainer>
      </ThemeProvider>
    )
  }
}


const DecoratedEmbedVideoPlayer = withTranslation('cart')(logic(EmbedVideoPlayer))

DecoratedEmbedVideoPlayer.defaultProps = Object.create({gfyPlugin: VIDEO_EMBED_KEY}, {
  id: {
    enumerable: true,
    get: () => cuid()
  }
});

export default DecoratedEmbedVideoPlayer
